import { render, staticRenderFns } from "./pvideo.vue?vue&type=template&id=fd0ea314&scoped=true&"
import script from "./pvideo.vue?vue&type=script&lang=js&"
export * from "./pvideo.vue?vue&type=script&lang=js&"
import style0 from "./pvideo.vue?vue&type=style&index=0&id=fd0ea314&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0ea314",
  null
  
)

export default component.exports